import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import {
  getUnRestrictedItemsStart,
  addRestrictedItemsStart,
  deleteRestrictedItemsStart
} from '../../../store/redux-slices/fetchData'
import { toast } from '../../../components/Toast'
import useDidMountEffect from '../../../utils/useDidMountEffect'
import { addGamesToSubCategoryStart, getAllGamesStart } from '../../../store/redux-slices/superAdminCasinoManagement'
import { getAllCasinoGamesStart } from '../../../store/redux-slices/superAdminCasinoManagement'

const useAddGames = () => {
  const dispatch = useDispatch()
  const { countryId } = useParams()
  const navigate = useNavigate()
  const { state: { subCategoryName="" } } = useLocation()

  const [selectedTab, setSelectedTab] = useState('restricted-games')
  const [selectedGames, setSelectedGames] = useState({ count: 0, rows: [] })
  const [removedGames, setRemovedGames] = useState({ count: 0, rows: [] })
  const [search, setSearch] = useState('')

  const [unRestrictedItemsLimit, setUnRestrictedItemsLimit] = useState(15)
  const [unRestrictedItemsPage, setUnRestrictedItemsPage] = useState(1)
  const isInitialRender = useDidMountEffect()

  const { loading, casinoGamesData, gameSubCategory,allProviders, casinoProvidersData } = useSelector(
    (state) => state.superAdminCasino
  )
  const unRestrictedItemsTotalPages = Math.ceil(casinoGamesData?.count / unRestrictedItemsLimit)
  const { gameSubCategoryId } = useParams()
  useEffect(() => {
    if (!isInitialRender) {
      const delayDebounceFn = setTimeout(() => {
        if (unRestrictedItemsPage === 1) {
          dispatch(getAllCasinoGamesStart({
            limit: unRestrictedItemsLimit,
      pageNo: unRestrictedItemsPage, 
      addGame: true,
      search,
      casinoCategoryId: '',
      isActive: '',
      tenantId: '',
      selectedProvider:''
          }))
        } else {
          setUnRestrictedItemsPage(1)
        }
      }, 1000)

      return () => clearTimeout(delayDebounceFn)
    }
  }, [search])

  useEffect(() => {
    dispatch(getAllCasinoGamesStart({
      limit: unRestrictedItemsLimit,
      pageNo: unRestrictedItemsPage, 
      addGame: true,
      search,
      casinoCategoryId: '',
      isActive: '',
      tenantId: '',
      selectedProvider:'',
      gameSubCategoryId:gameSubCategoryId
    }))
  }, [unRestrictedItemsLimit, unRestrictedItemsPage])

  const getProviderName = (id) =>
  casinoProvidersData?.rows.find((val) => val.casinoProviderId === id)?.name
  const addGame = (game) => {
    const gameExists = ({ ...selectedGames }
      .rows
      .findIndex(g => g.casinoGameId === game.casinoGameId))

    if (gameExists === -1) {
      setSelectedGames({ count: selectedGames.count + 1, rows: [...selectedGames.rows, game] })
    } else {
      toast('Already added this game', 'error')
    }
  }

  const removeGame = (gameId) => {
    const updatedGameRows = [...selectedGames.rows].filter(g => g.casinoGameId !== gameId)
    setSelectedGames({ count: selectedGames.count - 1, rows: updatedGameRows })
  }

  const addRestrictedGames = () => {
    const games = [...selectedGames.rows].map(g => g.casinoGameId)

    dispatch(addGamesToSubCategoryStart({ gameSubCategoryId, games,  navigate }))
  }

  const addDeleteGame = (game) => {
    const gameExists = ({ ...removedGames }
      .rows
      .findIndex(g => g.casinoGameId === game.casinoGameId))

    if (gameExists === -1) {
      setRemovedGames({ count: removedGames.count + 1, rows: [...removedGames.rows, game] })
    } else {
      toast('Already added this Game', 'error')
    }
  }

  const removeDeleteGame = (gameId) => {
    const updatedGameRows = [...removedGames.rows].filter(g => g.casinoGameId !== gameId)
    setRemovedGames({ count: removedGames.count - 1, rows: updatedGameRows })
  }

  const removeRestrictedGame = () => {
    const games = [...removedGames.rows].map(g => g.casinoGameId)

    dispatch(deleteRestrictedItemsStart({ type: 'games', games, countryId, navigate }))
  }

  return {
    loading,
     unRestrictedItemsLimit,
    setUnRestrictedItemsLimit,
    setUnRestrictedItemsPage,
    unRestrictedItemsPage,
    unRestrictedItemsTotalPages,
    selectedTab,
    setSelectedTab,
    casinoGamesData,
    addGame,
    selectedGames,
    removeGame,
    addRestrictedGames,
    addDeleteGame,
    removeDeleteGame,
    removeRestrictedGame,
    removedGames,
    search,
    setSearch,
    getProviderName,
    subCategoryName
  }
}

export default useAddGames
